import { render, staticRenderFns } from "./ContentAdviceBlock.vue?vue&type=template&id=8b5c1026"
import script from "./ContentAdviceBlock.vue?vue&type=script&lang=js"
export * from "./ContentAdviceBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentAdviceBlock.vue?vue&type=style&index=0&id=8b5c1026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports